export default function AuditLogs() {
  return (
    <section className="panel p-5">
      <h3 className="text-base font-semibold">Audit Logs</h3>
      <p className="mt-2 text-sm text-mutedGray dark:text-darkTextSecondary">
        Audit trail scaffold is ready. Next phase should connect to backend activity and admin action logs.
      </p>
    </section>
  );
}
